import React from "react";
import "./FarmerMessage.css"; // Import styles
import { useShoppingContext } from "../../../context/ShoppingContext";

const FarmerMessage = ({ message, buttonText, onClick }) => {
  const { setShowFarmer, showFarmer } = useShoppingContext();
  return (
    <div className="farmer-message-container">
      <img
        onClick={() => setShowFarmer(!showFarmer)}
        src="/images/farmer.webp"
        alt="Farmer"
        className="farmer-image"
      />
      <p className="farmer-message">{message}</p>
      <button className="btn btn-green" onClick={onClick}>
        {buttonText}
      </button>
    </div>
  );
};

export default FarmerMessage;
